var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.error)?_c('app-error',{attrs:{"error":_vm.error}}):_vm._e(),(!_vm.organization)?_c('app-loader',{attrs:{"large":""}}):_c('organization-editor',{on:{"submit":function($event){return _vm.update($event)}},model:{value:(_vm.organization),callback:function ($$v) {_vm.organization=$$v},expression:"organization"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }